let proximity = 80,
    magnetStrong = 3,
    magnetWeak = 1.2,
    mouseX,
    mouseY,
    distance,
    glowRect,
    currChapter = 1,
    currColor = '',
    textSpinnerLi;

const linkCircle = document.querySelector(".js-link-circle"),
    glowFollow1 = document.querySelector(".js-glow-follow-1"),
    glowFollow2 = document.querySelector(".js-glow-follow-2"),
    circleLinks = document.querySelectorAll(".js-circle-link"),
    glow = document.querySelector(".js-glow"),
    textSpinner = document.querySelector(".js-text-spinner");

if (typeof circleLinks != "undefined" && circleLinks != null && circleLinks.length > 0) { 
    
    circleLinks.forEach((btn) => {
        btn.addEventListener("mouseenter", (e) => {
            //textSpinnerLi[0].classList.remove("is-active");
            glow.classList.remove("chapter-" + currColor);
            textSpinnerLi[currChapter].classList.remove("is-active");
            currChapter = btn.dataset.number; 
            currColor = btn.dataset.color;
            glow.classList.add("chapter-" + currColor);
            textSpinnerLi[currChapter].classList.add("is-active");
        });
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            const buttonNum = parseInt(btn.dataset.number);
            const assocChap = document.querySelector(
                `.js-chapter-section-${buttonNum}`
            );
            disableScrollBtn();
            scrollToChap(assocChap);
        });
    });


    glow.addEventListener("mouseleave", (e) => {
        textSpinnerLi[currChapter].classList.remove("is-active");
       // textSpinnerLi[0].classList.add("is-active");
    });

    linkCircle.addEventListener("mousemove", glowMove);

    textSpinnerLi = textSpinner.querySelectorAll(".js-text-spinner-li");

    gsap.to(textSpinner, {
        rotation: "360",
        duration: 40,
        ease: "none",
        repeat: -1
    });

}


function glowMove(e) {
    mouseX = e.pageX;
    mouseY = e.pageY;
    glowRect = glowFollow1.getBoundingClientRect();
    distance = calculatedistance(mouseX, mouseY);

    if (distance < proximity) {
        let relativeX = mouseX - (glowRect.left + glowRect.width / 2),
            relativeY = mouseY - (glowRect.top + glowRect.height / 2);
        glowFollow1.style.transform =
            "translate(" +
            relativeX / magnetStrong +
            "px, " +
            relativeY / magnetStrong +
            "px)";
        glowFollow2.style.transform =
            "translate(" +
            relativeX / magnetWeak +
            "px, " +
            relativeY / magnetWeak +
            "px)";
    } else {
        glowFollow1.style.transform = "translate(0)";
        glowFollow2.style.transform = "translate(0)";
    }
}

function calculatedistance(mouseX, mouseY) {
    return (
        Math.floor(
            Math.sqrt(
                Math.pow(mouseX - (glowRect.left + glowRect.width / 2), 2) +
                    Math.pow(mouseY - (glowRect.top + glowRect.height / 2), 2)
            )
        ) - Math.round(glowRect.width / 2)
    );
}
